const allReviews = [
	{
		name: 'Aya Ahmad',
		role: 'Founder - Fyne Jewellery',
		text: "I can definitely say the team's communication was spot on. They care about their client's happiness and will work hard to meet expectations with a lot of patience and support.",
		clutchUrl: 'https://clutch.co/profile/vevol-media#review-2008182',
		projectUrl: '/work/fyne-jewellery',
		isRomanian: false,
	},
	{
		name: "Rory O'Neill",
		role: 'Director, Lumired',
		text: 'Vevol Media understood exactly what we required, even before we signed any contract. They provided a lot of insights, ideas, and recommendations.',
		clutchUrl: 'https://clutch.co/profile/vevol-media#review-2006152',
		projectUrl: '/work/lumired',
		isRomanian: false,
	},
	{
		name: 'Sarah Liu',
		role: 'CMO - ToplCup',
		text: 'We find their yes-can-do attitude impressive and they are always able to come up with a solution to our ridiculous requests. After launching our site for a week, our conversion rate has doubled. We have received great feedback on the UX and look & feel of the website. Amazing work!',
		clutchUrl: 'https://clutch.co/profile/vevol-media?page=1#review-1807527',
		projectUrl: '/work/topl-cup',
		isRomanian: false,
	},
	{
		name: 'Victor Stan',
		role: 'Founder - Alienstore',
		text: 'De la început până la sfârșit, colaborarea noastră cu Vevol Media a fost excelentă. Au livrat un magazin Shopify rapid, funcțional și frumos proiectat, clasat în top 24% al lansărilor din acea săptămână și cu un scor SEO de 96 din 100.',
		clutchUrl: 'https://clutch.co/go-to-review/3b8103f2-505f-422e-9d7e-292cb56f2c13/6630',
		isRomanian: true,
	},
	{
		name: 'Ștefan Munteanu',
		role: 'Owner - A&S Market',
		text: 'Vevol Media este o echipă profesionistă, muncitoare și dedicată. Ne-au construit și optimizat site-ul Shopify, au gestionat marketingul și ne-au ajutat să ajungem în top 5% al site-urilor de tip marketplace. Comunicarea lor este excelentă, iar livrările sunt mereu punctuale și în buget.',
		clutchUrl: 'https://clutch.co/go-to-review/3b8103f2-505f-422e-9d7e-292cb56f2c13/57988',
		isRomanian: true,
	},
	{
		name: 'Razvan Rusu',
		role: 'Owner - Răzvan Idicel',
		text: 'Vevol Media a livrat un site e-commerce bine realizat și accesibil, conectat cu Odoo, și a depășit așteptările prin implicare și livrare rapidă. Impresia generală e excelentă — este unul dintre cele mai atractive site-uri din piața noastră.',
		clutchUrl: 'https://clutch.co/go-to-review/3b8103f2-505f-422e-9d7e-292cb56f2c13/48460',
		isRomanian: true,
	},
	{
		name: 'Ionel Mirea',
		role: 'E-Commerce Director - Atomico România',
		text: 'Vevol Media a avut o atitudine foarte pozitivă față de fiecare provocare în dezvoltarea noului nostru webshop Shopify. Au livrat la timp, au comunicat eficient și au venit cu soluții inteligente pe tot parcursul proiectului. Receptivitatea lor a contribuit decisiv la succes.',
		clutchUrl: 'https://clutch.co/go-to-review/3b8103f2-505f-422e-9d7e-292cb56f2c13/320695',
		isRomanian: true,
	},
];

export default allReviews;
